module.exports = __webpack_public_path__ + "img/directory.f436eab8.svg";